// @flow
import PageHubCentenaire from 'components/page/template/PageHubCentenaire';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/page/template/PageHubCentenaire';
import { fetchPageList } from 'actions/pageActions';
import { fetchCentenaireClubs, fetchCentenaireDocuments } from 'actions/centenaireActions';
import { setQueryCentenaire } from 'actions/filterOptionsActions';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageListState.title,
    description: state.pageListState.description,
    label: state.pageListState.label,
    featured_media: state.pageListState.featured_media,
    meta_title: state.pageListState.meta_title,
    meta_description: state.pageListState.meta_description,
    redirection: state.pageListState.redirection,
    searchCities: [],
    searchClubs: [],
    clubs: state.centenaireState.clubs,
    total: state.centenaireState.total,
    documents: state.centenaireState.documents,
    statusDocuments: state.centenaireState.status,
    status: state.centenaireState.statusClubs,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchClubsPreview: () => dispatch(fetchCentenaireClubs()),
    fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
    fetchCentenaireDocuments: (data: Object) => dispatch(fetchCentenaireDocuments(data)),
    setQueryCentenaire: (queryCentenaire: string) => dispatch(setQueryCentenaire(queryCentenaire)),
  })
)(PageHubCentenaire);
